var config = function (C) {
  C.APP_NAME = "onboarding";
  C.userUrl = "/api/onboarding/user";

  C.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  window["C"] = C;
};

config.$inject = ["C"];

tiz.config(config);
